function getFechaSantiago(fecha = new Date()) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Santiago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(fecha); // → "YYYY-MM-DD"
}

function getFechaCompletaSantiago(fecha = new Date()) {
    const fechaISO = getFechaSantiago(fecha);
    const hora = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Santiago',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).formatToParts(fecha);
    const horaMap = Object.fromEntries(hora.map(p => [p.type, p.value]));
    return new Date(`${fechaISO}T${horaMap.hour}:${horaMap.minute}:${horaMap.second}`);
}

function esFeriado(fechaISO) {
    const feriados = ['2026-06-29','2026-05-21','2025-06-29','2026-07-16'];
    return feriados.includes(fechaISO);
}

function obtenerProximoDiaHabil(fechaISO) {
    let fecha = new Date(`${fechaISO}T00:00:00`);
    while (true) {
        fecha.setDate(fecha.getDate() + 1);
        const fechaStr = getFechaSantiago(fecha);
        const dia = fecha.getDay();
        if (!esFeriado(fechaStr) && dia !== 0) {
            return fechaStr;
        }
    }
}

function mensajeProximoHabil(hoyISO, proximoISO) {
    const hoy = new Date(`${hoyISO}T00:00:00`);
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    const mananaISO = getFechaSantiago(manana);

    if (proximoISO === mananaISO) return '¡Llega <span class="remaining-time">MAÑANA</span>!</span>';

    const dias = ["DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO"];
    const dia = new Date(`${proximoISO}T00:00:00`).getDay();
    return `¡Llega el <span class="remaining-time">${dias[dia]}</span>!</span>`;
}

function updateCountdown(cutOffTime) {
    const now = getFechaCompletaSantiago();
    let diff = cutOffTime - now;
    diff = Math.max(diff, 0);

    const h = Math.floor(diff / (1000 * 60 * 60));
    const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const s = Math.floor((diff % (1000 * 60)) / 1000);
    const pad = n => n.toString().padStart(2, '0');

    (document.getElementById("delivery-message")||{}).innerHTML =
        "¡Llega HOY!<br><span class='santiago'>Aún estás a tiempo:</span><br>" +
        `<span class='remaining-time'>${pad(h)} horas, ${pad(m)} min, y ${pad(s)} seg</span>`;
}

function deliveryMessage() {
    const now = getFechaCompletaSantiago();
    const hoyISO = getFechaSantiago(now);
    const dia = now.getDay();
    const cutOffTime = new Date(now);
    cutOffTime.setHours(14, 0, 0, 0);

    if (esFeriado(hoyISO)) {
        const proximo = obtenerProximoDiaHabil(hoyISO);
        (document.getElementById("delivery-message")||{}).innerHTML = mensajeProximoHabil(hoyISO, proximo);
        return;
    }

    if (dia >= 1 && dia <= 6 && now <= cutOffTime) {
        updateCountdown(cutOffTime);
        setInterval(() => updateCountdown(cutOffTime), 1000);
    } else {
        const proximo = obtenerProximoDiaHabil(hoyISO);
        (document.getElementById("delivery-message")||{}).innerHTML = mensajeProximoHabil(hoyISO, proximo);
    }
}

deliveryMessage();

